<template>
<a class="btn-notifications nav-link py-2 px-2 position-relative" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNotifications" aria-controls= "offcanvasWithBackdrop"><i class="bi bi-bell fs-5"></i> <span class="d-lg-none ps-1">{{ label }}</span>
    <span v-if="count > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger notifications-count">{{ count }} <span class="visually-hidden">{{ unreadLabel }}</span></span>
</a>
</template>
<style>
    .notifications-count {
        top: 1em !important;
        left: 80% !important;
    }
</style>

<script>
export default {
    data () {
        return {
            count: 0,
        };
    },

    methods: {
        fetchNotifications: function() {
            axios.get(this.fetch_data_url)
                .then((response) => {
                    this.count = response['data'];
            });
        },
    },

    props: {
        fetch_data_url: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        unreadLabel: {
            type: String,
            default: '',
        },
    },

    created() {
        this.fetchNotifications();
    },

    mounted () {
        // Bind event to update notofication count (uses developit/mitt)
        this.eventBus.on('update_notication_count', (args) => {
            this.fetchNotifications();
        })
    },
}
</script>
